import { userDispenserFactory } from '@haaretz/s-atoms/user';
export default function userDispenserMiddleware({ ctx }) {
    if (!ctx.req?.cookies) {
        throw new Error('No cookies found in request');
    }
    const cookie = Object.entries(ctx.req.cookies).reduce((acc, [key, value])=>{
        return `${acc}${key}=${value};`;
    }, '');
    const user = userDispenserFactory(cookie);
    return Promise.resolve({
        user
    });
}

//# sourceMappingURL=userDispenserMiddleware.js.map